/* HAFA MegaMenu V2 "Hover-Stage"
 * ---------------------------------------------------------------
 * Sehr klein: alle Inhalte sind server-seitig vor-gerendert.
 * Dieses Script kümmert sich nur um:
 *   - Open/Close beim Hover/Focus auf dem Trigger-Link
 *   - Aktive Kategorie wechseln (Schiene/Subs/Bühne synchron)
 *   - Tastatur: ESC schließt, ↑/↓ in der Liste navigieren
 *   - Auto-Wire des Trigger-Links anhand `data-hafa-mv2-trigger`
 *     ODER (Fallback) anhand des Linklist-Handles im Hauptmenü
 * --------------------------------------------------------------- */
(function () {
  'use strict';

  const menu = document.querySelector('[data-hafa-mv2]');
  if (!menu) return;

  // Settings akzeptieren KOMMA- oder PIPE-Listen — robust gegen Sprache + Umbenennung.
  // Beispiel: "produkte,sklep,shop" matcht jeden dieser Handle-/ID-Werte im DOM.
  // WICHTIG: Sichere Fallback-Liste wird IMMER zusätzlich angehängt (deduped), damit
  // ein einzelner Wert im Setting (z.B. "produkte") nach Umbenennung trotzdem matcht.
  function splitList(s) {
    return (s || '').toLowerCase().split(/[,|]/).map(x => x.trim()).filter(Boolean);
  }
  const FALLBACK_HANDLES = ['produkte','sklep','shop'];
  const FALLBACK_TEXTS   = ['produkte','sklep','shop','katalog'];
  const triggerHandles = [...new Set([...splitList(menu.dataset.hafaMv2TriggerHandle), ...FALLBACK_HANDLES])];
  const triggerTexts   = [...new Set([...splitList(menu.dataset.hafaMv2TriggerText),   ...FALLBACK_TEXTS])];

  const items  = menu.querySelectorAll('[data-mv2-cat]');
  const subs   = menu.querySelectorAll('[data-mv2-subs]');
  const stages = menu.querySelectorAll('[data-mv2-stage]');
  const rail   = menu.querySelector('.hafa-mv2__rail');
  const subsWrap   = menu.querySelector('.hafa-mv2__subs-wrap');
  const stageWrap  = menu.querySelector('.hafa-mv2__stage-wrap');

  if (!items.length) return;

  // Auf Mobile: pro Rail-Item markieren ob es Subs hat (für CSS-Pfeil-Variation)
  items.forEach(el => {
    const key = el.dataset.mv2Cat;
    const subEl = menu.querySelector(`[data-mv2-subs="${key}"]`);
    const hasSubs = subEl && subEl.querySelector('.hafa-mv2__sub-grid');
    el.dataset.mv2HasSubs = hasSubs ? 'true' : 'false';
  });

  // Mobile-Detection (live, weil resize zwischen Portrait/Landscape oder Devtools)
  const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

  // Bei jedem aktivierten Item: Subs + Stage direkt hinter das Item ins DOM verschieben (Mobile-Accordion).
  // Auf Desktop: alles bleibt in seinem Grid-Slot.
  function reflowMobile(activeEl) {
    if (!isMobile()) return;
    const key = activeEl.dataset.mv2Cat;
    const subEl   = menu.querySelector(`[data-mv2-subs="${key}"]`);
    const stageEl = menu.querySelector(`[data-mv2-stage="${key}"]`);
    if (subEl && activeEl.nextElementSibling !== subEl) {
      activeEl.insertAdjacentElement('afterend', subEl);
    }
    if (stageEl) {
      // Stage hinter die Subs
      if (subEl && subEl.nextElementSibling !== stageEl) {
        subEl.insertAdjacentElement('afterend', stageEl);
      } else if (!subEl && activeEl.nextElementSibling !== stageEl) {
        activeEl.insertAdjacentElement('afterend', stageEl);
      }
    }
  }

  // ---- Active-State-Synchronisation ----
  function setActive(key) {
    let matched = false;
    let activeEl = null;
    items.forEach(el => {
      const isActive = el.dataset.mv2Cat === key;
      el.classList.toggle('is-active', isActive);
      if (isActive) { matched = true; activeEl = el; }
    });
    subs.forEach(el => el.dataset.active = (el.dataset.mv2Subs === key) ? 'true' : 'false');
    stages.forEach(el => el.dataset.active = (el.dataset.mv2Stage === key) ? 'true' : 'false');
    if (activeEl) reflowMobile(activeEl);
    return matched;
  }

  items.forEach((el, idx) => {
    // Desktop: hover + focus aktiviert
    el.addEventListener('mouseenter', () => { if (!isMobile()) setActive(el.dataset.mv2Cat); });
    el.addEventListener('focus',      () => { if (!isMobile()) setActive(el.dataset.mv2Cat); });

    // Mobile: tap auf Eintrag
    //   - mit Subs:  Toggle Accordion (kein Navigate)
    //   - ohne Subs: Navigate direkt zur URL
    el.addEventListener('click', (e) => {
      if (!isMobile()) return;
      if (el.dataset.mv2HasSubs === 'true') {
        e.preventDefault();
        const wasActive = el.classList.contains('is-active');
        if (wasActive) {
          // collapse: clear active state
          items.forEach(x => x.classList.remove('is-active'));
          subs.forEach(x => x.dataset.active = 'false');
          stages.forEach(x => x.dataset.active = 'false');
        } else {
          setActive(el.dataset.mv2Cat);
        }
      }
      // sonst: standard <a>-Navigation läuft
    });

    el.addEventListener('keydown', (e) => {
      if (isMobile()) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const dir = e.key === 'ArrowDown' ? 1 : -1;
        const next = items[(idx + dir + items.length) % items.length];
        if (next) next.focus();
      }
    });
  });

  // ---- Open/Close-Steuerung ----
  let closeTimer = null;

  // Positioniert das Menü direkt unter dem (ggf. sticky) Header.
  // Dawn nutzt <sticky-header> als Web-Component-Wrapper; ohne sticky
  // fallback auf <header>. Bei „scroll-up" wird der sticky-header
  // sichtbar und sein bottom ist der korrekte Anker.
  function positionMenu() {
    const stickyHeader = document.querySelector('sticky-header');
    let anchor = null;
    if (stickyHeader && stickyHeader.offsetHeight > 0) {
      anchor = stickyHeader;
    } else {
      anchor = document.querySelector('header.header')
            || document.querySelector('.section-header')
            || document.querySelector('header');
    }
    if (!anchor) return;
    const bottom = anchor.getBoundingClientRect().bottom;
    // Negative oder Null-Werte (Header oberhalb Viewport) → auf 0 clampen
    menu.style.setProperty('--hafa-mv2-top', Math.max(0, bottom) + 'px');
  }

  // Schließt den Dawn-Mobile-Drawer (Hamburger), damit er nicht hinter V2 sichtbar
  // bleibt oder Backdrop-Taps abfängt. Aggressiv — auch Body-Styles + Animation-Reset.
  function closeDawnMobileDrawer() {
    // Alle Dawn-<details> mit „menu-drawer" / „mega-menu" zu
    document.querySelectorAll(
      'details.menu-drawer-container, details[id*="menu-drawer"], details.mega-menu'
    ).forEach(d => {
      d.removeAttribute('open');
    });
    // Dawn-Web-Components
    document.querySelectorAll('header-drawer').forEach(d => {
      try {
        if (typeof d.close === 'function') d.close();
        d.removeAttribute('open');
      } catch (e) {}
    });
    // Body-Klassen und Inline-Styles die Dawn setzt
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-mobile');
    document.body.style.removeProperty('overflow');
    document.documentElement.classList.remove('overflow-hidden');
  }

  const open  = () => {
    clearTimeout(closeTimer);
    positionMenu();
    menu.dataset.open = 'true';
    if (isMobile()) {
      document.documentElement.classList.add('hafa-mv2-mobile-open');
      closeDawnMobileDrawer();
      // Auf Mobile soll initial KEIN Item aktiv sein (Liste sichtbar, User wählt)
      items.forEach(x => x.classList.remove('is-active'));
      subs.forEach(x => x.dataset.active = 'false');
      stages.forEach(x => x.dataset.active = 'false');
    }
  };
  const close = () => {
    if (isMobile()) {
      menu.dataset.open = 'false';
      document.documentElement.classList.remove('hafa-mv2-mobile-open');
    } else {
      closeTimer = setTimeout(() => { menu.dataset.open = 'false'; }, 150);
    }
  };
  const closeImmediate = () => {
    clearTimeout(closeTimer);
    menu.dataset.open = 'false';
    document.documentElement.classList.remove('hafa-mv2-mobile-open');
  };

  // Close-Button (Mobile-only-visible, kann auf Desktop auch verwendet werden)
  const closeBtn = menu.querySelector('[data-hafa-mv2-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeImmediate);

  // Während offen: Position bei Scroll/Resize aktuell halten
  let raf = null;
  function onScrollOrResize() {
    if (menu.dataset.open !== 'true') return;
    if (raf) return;
    raf = requestAnimationFrame(() => { positionMenu(); raf = null; });
  }
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });

  menu.addEventListener('mouseenter', open);
  menu.addEventListener('mouseleave', close);

  // Trigger-Link finden:
  //  Priorität 1: Element mit data-hafa-mv2-trigger="true"
  //  Priorität 2: Link im Hauptmenü, dessen href den triggerHandle enthält
  //  Priorität 3: Link, dessen sichtbarer Text triggerText matched
  function findTriggers() {
    const explicit = document.querySelectorAll('[data-hafa-mv2-trigger="true"]');
    if (explicit.length) return Array.from(explicit);

    // Kandidaten umfassen auch <summary> (Dawn nutzt <details>/<summary> für Top-Level-Items mit Sub-Menü)
    const candidates = document.querySelectorAll(
      '.header__menu-item, .header__inline-menu a, .header__inline-menu summary, header nav a, header nav summary'
    );
    const matches = new Set();
    candidates.forEach(el => {
      const href    = (el.getAttribute('href') || el.querySelector('a')?.getAttribute('href') || '').toLowerCase();
      const id      = (el.id || '').toLowerCase();
      const rawText = (el.textContent || '').toLowerCase().trim();

      // 1. Match per Handle (in href ODER in summary-id, sprachunabhängig stabil)
      for (const h of triggerHandles) {
        if (href.includes('/' + h) || id.includes(h)) {
          matches.add(el);
          return;
        }
      }
      // 2. Match per sichtbarem Text (exact oder als Wort-Prefix)
      for (const t of triggerTexts) {
        if (rawText === t || rawText.startsWith(t + ' ') || rawText.startsWith(t + '\n')) {
          matches.add(el);
          return;
        }
      }
    });
    return Array.from(matches);
  }

  const triggers = findTriggers();

  triggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', close);
    trigger.addEventListener('focus', open);

    // touchstart fires VOR Dawn-Drawer-JS. Sofort handeln, sonst startet Dawn
    // seine eigene Toggle-Animation und mein V2-Open wird unsichtbar dahinter.
    trigger.addEventListener('touchstart', (e) => {
      if (!isMobile()) return;
      e.preventDefault();          // verhindert ghost-click + default details-toggle
      e.stopImmediatePropagation();
      const det = trigger.closest('details');
      if (det) det.removeAttribute('open');
      closeDawnMobileDrawer();
      open();
    }, { passive: false, capture: true });

    // Click-Fallback (Desktop + Browsers ohne touchstart)
    trigger.addEventListener('click', (e) => {
      const det = trigger.closest('details');
      if (det) {
        e.preventDefault();
        e.stopPropagation();
        det.removeAttribute('open');
      }
      if (isMobile()) closeDawnMobileDrawer();
      open();
    }, { capture: true });
  });

  // Falls das Dawn-<details> trotzdem mal openen sollte (z.B. via keyboard) — sofort wieder zumachen
  triggers.forEach(trigger => {
    const det = trigger.closest('details');
    if (!det) return;
    new MutationObserver(() => {
      if (det.hasAttribute('open')) det.removeAttribute('open');
    }).observe(det, { attributes: true, attributeFilter: ['open'] });
  });

  // ESC und Klick außerhalb
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') menu.dataset.open = 'false';
  });
  document.addEventListener('click', (e) => {
    if (menu.dataset.open !== 'true') return;
    if (menu.contains(e.target)) return;
    if (triggers.some(t => t.contains(e.target))) return;
    menu.dataset.open = 'false';
  });

  // Debug-Hilfe — wenn Dev-Mode oder URL-Param ?hafa-debug=1
  if (location.search.includes('hafa-debug=1')) {
    console.info('[hafa-mv2]', {
      menu, triggers, items: items.length, subs: subs.length, stages: stages.length
    });
  }
})();
